import React from "react";
import { DatePicker } from "antd";
import { useIntl } from "react-intl";
import { IInstallationFieldProps } from "./InstallationField.props";

import styles from "./InstallationField.module.scss";
import { useInstallationFieldControl } from "./useInstallationFieldControl";
import dayjs from "dayjs";

const FORMAT = "DD-MM-YYYY";

export default function InstallationField(props: IInstallationFieldProps) {
  const { formatMessage } = useIntl();

  const control = useInstallationFieldControl(props);

  return (
    <div className={styles.field}>
      <label>
        {formatMessage({ id: "machines.more.instalation_date.title" })}
      </label>
      <DatePicker
        size="small"
        className={styles.picker}
        value={control.date ? dayjs(Number(control.date)) : undefined}
        onChange={control.getDate}
        format={FORMAT}
        placeholder={props.placeholder}
        clearIcon
      />

      <input id={props.id} value={control.date} hidden />
    </div>
  );
}
